export enum SolutionRulesConfigurationField {
  RuleName = 'ruleName',
  Enabled = 'enabled',
  DeviceTemplate = 'deviceTemplate',
  Action = 'action',
}

export type SolutionRuleConfigurationItem = {
  id?: string;
  solutionId: string;
  siteIds: string[];
  enabled: boolean;
  name: string;
  conditionQueryOperator?: string;
  conditionQuery?: any[];
  timeAggregation: boolean;
  timeAggregationValueInMinutes: number;
  actionTypes?: string[];
  targetUrl?: string;
  sasToken?: string;
};

export enum SolutionRuleConfigurationField {
  Id = 'id',
  Name = 'name',
  Enabled = 'enabled',
  SiteIds = 'siteIds',
  ConditionQueryOperator = 'conditionQueryOperator',
  ConditionQuery = 'conditionQuery',
  TimeAggregation = 'timeAggregation',
  TimeAggregationValueInMinutes = 'timeAggregationValueInMinutes',
  ActionTypes = 'actionTypes',
  TargetUrl = 'targetUrl',
  SasToken = 'sasToken',
}

export enum SolutionRuleConfigurationFilterField {
  Property = 'Property',
  OperatorValue = 'OperatorValue',
  FilterValue = 'FilterValue',
}

export type SolutionRuleConfigurationFilter = {
  Property: string;
  OperatorValue: string;
  FilterValue: string;
};

export enum SolutionRuleConfigurationPreferences {
  Email = 'email',
  SMS = 'sms',
  TargetUrl = 'targetURL',
}
